import React from 'react';

const HeaderList = () => {
  return (
    <ul
      style={{ justifyContent: 'space-evenly' }}
      className="flex flex-col leading-relaxed pt-5 md:flex-row"
    >
      <li className="mb-4 md:pr-10">
        <p className="text-gray-700 text-lg md:text-xl">
          <span className="flex items-center">
            <span className="w-3 h-3 bg-red-100 block mr-3" />
            <span>Líneas de crédito desde </span>
          </span>
          <span className="text-green-100 block ml-5">$300 mil a</span>
          <span className="text-green-100 block ml-5">
            $3 millones <span className="text-sm">MXN</span>
          </span>
        </p>
      </li>
      <li className="mb-4 md:pr-10">
        <p className="text-gray-700 text-lg md:text-xl">
          <span className="flex items-center">
            <span className="w-3 h-3 bg-red-100 block mr-3" />
            <span>Tasa promedio mensual</span>
          </span>
          <span className="text-green-100 block ml-6">2%</span>
        </p>
      </li>
      <li>
        <p className="text-gray-700 text-lg md:text-xl">
          <span className="flex items-center">
            <span className="w-3 h-3 bg-red-100 block mr-3" />
            <span>Aprobación de línea de crédito en </span>
          </span>
          <span className="text-green-100 block ml-5">72 horas</span>
        </p>
      </li>
    </ul>
  );
};

export default HeaderList;
